import _Renderer from '../[eid]';
export var __N_SSP = true;
export default _Renderer;
